import { initialSyncService, syncQueueService } from "@/services/sync";
import { enhancedImageCacheService } from "@/services/offline/image-cache-enhanced.service";
import { clearAllTables } from "@/db/offlineDb";
import { syncValidationService } from "@/services/sync/SyncValidationService";
import { getValidUserId } from "@/utils/validation";
import { clearCachedUserId } from "./sessionCache";
import { clearDeviceAppVersionSyncState } from "./device.service";
import logger from "@/utils/logger";

// Gestisce la pulizia locale dopo il logout (cache, IndexedDB, tema, sync)
export const logoutCleanupService = {
  async performCleanup(
    setThemeId: (id: string) => Promise<void> | void,
    refreshTheme: () => Promise<void> | void
  ) {
    const userId = getValidUserId();

    initialSyncService.cancelSync();
    await syncQueueService.cancelAll();
    // Al logout azzeriamo anche la coda di download persistita: non vogliamo
    // ripristinare i task del vecchio utente al prossimo avvio.
    syncQueueService.clearPersisted();
    await enhancedImageCacheService.clearCache();
    await clearAllTables();

    if (userId) {
      logger.log("[LOGOUT_CLEANUP] \uD83D\uDCE4 Invoking performComprehensiveValidation", {
        userId: userId.substring(0, 8)
      });
      await syncValidationService.performComprehensiveValidation(userId, true);
    }

    localStorage.removeItem("userId");
    clearCachedUserId();
    localStorage.removeItem("userIsPremium");
    localStorage.removeItem("deviceRegisteredAt");
    localStorage.removeItem("deviceRegistrationPending");
    clearDeviceAppVersionSyncState();

    await setThemeId("11111111-1111-1111-1111-111111111111");
    await refreshTheme();
  }
};
export default logoutCleanupService;
